import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
// @ts-ignore
import html2pdf from 'html2pdf.js';
import { environment } from 'src/environments/environment';
import { VisitFormModel } from '../../models/visit-form.model';
import { EventService } from 'src/app/core/services/event.service';
import Swal from 'sweetalert2';
import { FilesService } from 'src/app/core/services/files.service';

@Component({
  selector: 'app-visit-form-template',
  templateUrl: './visit-form-template.component.html',
  styleUrls: ['./visit-form-template.component.scss']
})
export class VisitFormTemplateComponent implements OnInit, AfterViewInit {

  @Input() visit!: VisitFormModel;
  @Input() entityData: any;
  @Input() isEdit: boolean = false;
  logoPath = `${environment.apiUrl}/${environment.dirLogoImage}/`;
  logostorePath = `${environment.apiUrl}/${environment.dirLogoStoreImage}/`;
  propertyPath = `${environment.apiUrl}${environment.dirPropertiesImages}/`;

  constructor(private eventService: EventService, private fileService: FilesService) { }

  ngOnInit(): void {
  }

  get isStore103(): boolean {
    const agentStoreId = Number(this.entityData?.storeId);
    return agentStoreId === 103
  }


  ngAfterViewInit(): void {
    this.generatePdf();
  }

  private getVisitFileName(): string {
    return `ficha-de-visita-${this.visit.property?.reference}.pdf`;
  }

  private getPdfOptions() {
    return {
      margin: [10, 10, 10, 10],
      filename: this.getVisitFileName(),
      image: { type: 'jpeg', quality: 0.9 },
      html2canvas: {
        scale: Math.min(window.devicePixelRatio || 1, 1.5),
        useCORS: true,
        allowTaint: false,
        imageTimeout: 4000,
        logging: false,
      },
      jsPDF: {
        unit: 'mm',
        format: 'a4',
        orientation: 'portrait',
        compress: true,
      }
    };
  }

  private downloadPdfBlob(pdfBlob: Blob): void {
    const url = URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.getVisitFileName();
    a.click();
    URL.revokeObjectURL(url);
  }

  private showVisitGenerationError(): void {
    this.eventService.broadcast('visit-generated');
    Swal.fire({
      title: 'Erro ao gerar Ficha de Visita',
      text: 'Ocorreu um erro ao guardar a Ficha de Visita. Tente novamente.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  }

  generatePdf() {
    const element = document.getElementById('visit-form');
    if (!element) return;
    const opt = this.getPdfOptions();
    html2pdf()
      .from(element)
      .set(opt)
      .outputPdf('blob')
      .then((pdfBlob: any) => {

        const formData = new FormData();
        formData.append('file', pdfBlob, this.getVisitFileName());
        const visitDateTime = new Date(`${this.visit.date}T${this.visit.time}`);
        formData.append('visitDate', visitDateTime.toISOString());
        formData.append('contactId', this.visit.contactId);
        formData.append('dealId', this.visit.dealId);
        formData.append('clientName', this.visit.clientName);
        formData.append('clientEmail', this.visit?.clientEmail || '');
        formData.append('clientContact', this.visit.clientContact);
        formData.append('agentEmail', this.visit.agentEmail);
        formData.append('responsible', this.visit.agentName);
        formData.append('listingAgent', this.visit.property?.listingAgent || this.visit.agentName);
        formData.append('type', this.visit.type);
        formData.append('property', JSON.stringify(this.visit?.property));
        formData.append('leadId', this.visit.leadId);
        formData.append('agentId', this.visit.agentId);
        // Visita já marcada à parte: gerar a ficha não deve criar outra.
        formData.append(
          'skipVisitCreation',
          this.visit?.skipVisitCreation ? 'true' : 'false',
        );
        if (!this.isEdit) {
          this.fileService.createVisitForm(formData, this.visit).subscribe({
            next: () => {
              element?.classList.add('d-none');
              this.downloadPdfBlob(pdfBlob);
              this.eventService.broadcast('visit-generated');
            },
            error: () => {
              this.showVisitGenerationError();
            }
          });
        } else {
          this.fileService.updateVisitForm(formData, this.visit.dealId).subscribe({
            next: () => {
              element?.classList.add('d-none');
              this.downloadPdfBlob(pdfBlob);
              this.eventService.broadcast('visit-generated');
            },
            error: () => {
              this.showVisitGenerationError();
            }
          });
        }
      })
      .catch(() => {
        this.showVisitGenerationError();
      });

  }

  getFullVisitDate(date: string): string {
    const visitDate = new Date(date);
    return `${visitDate.getDate()} de ${visitDate.toLocaleString('default', { month: 'long' })} de ${visitDate.getFullYear()}`;
  }
}
